import dayjs from "dayjs";
import dayLocaleData from "dayjs/plugin/localeData";
import { Button } from "antd";
import { useEffect, type FC } from "react";
import { useTranslation } from "react-i18next";
import { ButtonSelect } from "@/shared/Components";
import { useAppDispatch } from "@/services/store";
import { calendarSliceActions } from "@/features/calendar/model";
import { capitalizeMonth } from "@/shared/utils/capitalize";
import type { Dayjs } from "dayjs";
import styles from "./styles.module.scss";

dayjs.extend(dayLocaleData);

type CalendarHeaderProps = {
  value: Dayjs;
  onChange: (value: Dayjs) => void;
};

export const CalendarHeader: FC<CalendarHeaderProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const year = value.year();
  const month = value.month();
  const localeData = value.localeData();
  let current = value.clone();
  const setToday = () => {
    onChange(dayjs());
  };

  useEffect(() => {
    dispatch(calendarSliceActions.updateDateRange(value.toISOString()));
  }, [value]);

  return (
    <div className={styles.root}>
      <div
        className={styles.title}
      >{`${capitalizeMonth(localeData.months(value))} ${value.year()}`}</div>
      <div className={styles.selects}>
        <ButtonSelect
          className={styles.year}
          onChange={(newYear) => {
            const now = value.clone().year(newYear);
            onChange(now);
          }}
          value={year}
          options={Array.from({ length: 20 }).map((_, index) => {
            return {
              value: year + index - 10,
              label: year + index - 10,
            };
          })}
        />
        <ButtonSelect
          className={styles.month}
          onChange={(newMonth) => {
            const now = value.clone().month(newMonth);
            onChange(now);
          }}
          value={month}
          options={Array.from({ length: 12 }).map((_, index) => {
            current = value.clone().month(index);
            current = current.month(index);
            return {
              value: index,
              label: capitalizeMonth(localeData.months(current)),
            };
          })}
        />
        <Button className={styles.today} onClick={setToday}>
          {t("common.today")}
        </Button>
      </div>
    </div>
  );
};
